<template>
  <div class="app-layout">
    <app-sidebar />
    <div class="app-content">
      <app-header />
      <main class="app-main">
        <router-view />
      </main>
    </div>
  </div>
</template>

<script>
import AppSidebar from './AppSidebar.vue'
import AppHeader from './AppHeader.vue'

export default {
  name: 'AppLayout',
  components: { AppSidebar, AppHeader }
}
</script>

<style scoped>
.app-layout {
  display: flex;
  min-height: 100vh;
}
.app-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  overflow: auto;
  background: #f5f5f5;
}
.app-main {
  flex: 1;
  padding: 28px;
}
</style>
